import {dataKey, scrollKey, Entry, languageKey} from "./model";
import {newsfeedService} from "./newsfeed-service";

document.addEventListener("DOMContentLoaded", async () => {
    const currentLang = location.pathname.startsWith("/en/") ? "en" : "de";

    if (!location.pathname.startsWith("/newsfeed") && !location.pathname.startsWith("/en/newsfeed-en")) {
        newsfeedService.clearSession();
        return;
    }

    if (sessionStorage.getItem(languageKey) != currentLang) {
        newsfeedService.clearSession();
    }

    sessionStorage.setItem(languageKey, currentLang);

    if (location.pathname == "/newsfeed" || location.pathname == "/newsfeed/" || location.pathname == "/en/newsfeed-en" || location.pathname == "/en/newsfeed-en/") {
        document.addEventListener("scrollend", () => {
            sessionStorage.setItem(scrollKey, String(window.scrollY));
        });

        newsfeedService.loadStories();

        if ((window.performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming).type == "reload") {
            newsfeedService.clearSession();

            await newsfeedService.loadNews();

            setTimeout(() => {
                window.scrollTo({top: 0});
            }, 500)
        } else {
            if (sessionStorage.getItem(dataKey)) {
                const items: Entry[] = JSON.parse(sessionStorage.getItem(dataKey));
                newsfeedService.appendNews(items);

                if (sessionStorage.getItem(scrollKey)) {
                    window.scrollTo({top: Number(sessionStorage.getItem(scrollKey))});
                }
            } else {
                await newsfeedService.loadNews();
            }
        }
    }
})

const loadMoreButton = async () => {
    await newsfeedService.loadNews()
}
globalThis.loadMoreButton = loadMoreButton;